import { Storage } from '@ionic/storage';
import { ModalController } from '@ionic/angular';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { WardrobeService } from 'src/app/services/wardrobe.service';
import { brand, color, condition, size, type } from 'src/app/constants/general.constant';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ProductBrandModel, ProductTypeModel } from 'src/app/models/wardrobe.model';
import { ChooseLocationModalComponent } from '../choose-location-modal/choose-location-modal.component';
import { ProductColorModel, ProductSizeModel, ProductConditionModel } from './../../models/wardrobe.model';
import { ProductCategoryModalComponent } from '../product-category-modal/product-category-modal.component';

@Component({
  selector: 'shc-category-filter-modal',
  templateUrl: './category-filter-modal.component.html',
  styleUrls: ['./category-filter-modal.component.scss'],
})
export class CategoryFilterModalComponent implements OnInit {
  form: UntypedFormGroup;
  @Input() type: string;
  @Input() data: string;
  selectedType: ProductTypeModel;
  selectedSize: ProductSizeModel;
  selectedBrand: ProductBrandModel;
  selectedColor: ProductColorModel;
  productConditions: Array<ProductConditionModel>;
  selectedLocation: {
    location: string
    latitude: number
    longitude: number
  };
  selectedCondition: ProductConditionModel
  resultCount: number = null;
  private resultCountTimeout: any;
  constructor(
    private modalCtrl: ModalController,
    private localStorage: Storage,
    private wardrobeService: WardrobeService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      price: new UntypedFormControl(null),
      size: new UntypedFormControl(null),
      condition: new UntypedFormControl(null),
      color: new UntypedFormControl(null),
      type: new UntypedFormControl(null),
      brand: new UntypedFormControl(null),
      location: new UntypedFormControl(null),
      latitude: new UntypedFormControl(null),
      longitude: new UntypedFormControl(null)
    });
    if (this.data) {
      this.patchFilters(this.data);
    }
    this.getProductConditions();
    this.updateResultCount();
  }

  updateResultCount() {
    clearTimeout(this.resultCountTimeout);
    this.resultCountTimeout = setTimeout(() => {
      const params: any = {
        page: 1,
        per_page: 1,
      };
      if (this.selectedColor?.id) { params.color_id = this.selectedColor.id; }
      if (this.selectedBrand?.id) { params.brand_id = this.selectedBrand.id; }
      if (this.selectedType?.id) { params.type_id = this.selectedType.id; }
      if (this.selectedSize?.id) { params.size_id = this.selectedSize.id; }
      if (this.selectedCondition?.id) { params.condition_id = this.selectedCondition.id; }
      this.wardrobeService.productsList(params).subscribe(
        (res) => {
          this.resultCount = res?.meta?.total ?? null;
        },
        () => {
          this.resultCount = null;
        },
      );
    }, 300);
  }

  setSelectedCondition(event){
    const selectedValue = event.target.value;
    this.selectedCondition = this.productConditions?.find(pro => pro?.rating === selectedValue);
  }

  getProductConditions() {
    this.wardrobeService.conditionsList().subscribe(res => {
      this.productConditions = res.data.filter(con => con.rating !== null);
    }, error => {
      this.errorService.handle(error);
    });
  }

  patchFilters(res: any) {
    this.form.patchValue({
      price: res.price,
      size: res.size,
      condition: res.condition,
      location: res.location,
      latitude: res.latitude,
      longitude: res.longitude,
    });
    this.selectedType = res.type;
    this.selectedColor = res.color;
    this.selectedBrand = res.brand;
    this.selectedSize = res.size;
    this.selectedLocation = {
      location: res.location,
      latitude: res.latitude,
      longitude: res.longitude
    };
  }

  async openProductCategoryModal(value: string) {
    const modal = await this.modalCtrl.create({
      component: ProductCategoryModalComponent,
      componentProps: {
        value,
        conditions: this.productConditions,
      },
      cssClass: 'product-category-modal-create',
      canDismiss: true,
      id: 'productCategory'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        if (value === brand) {
          this.selectedBrand = data.data;
        } else if (value === color) {
          this.selectedColor = data.data;
        } else if (value === type) {
          this.selectedType = data.data;
          this.selectedSize = null;
        } else if (value === size) {
          this.selectedSize = data.data;
        } else if (value === condition) {
          this.selectedCondition = data.data;
          this.form.get('condition')?.setValue(data.data.id);
        }
      }
      this.updateResultCount();
      // this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async openLocationModal() {
    const modal = await this.modalCtrl.create({
      component: ChooseLocationModalComponent,
      cssClass: 'location-selections-create',
      canDismiss: true,
      id: 'locationModal'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.selectedLocation = data.data;
        this.form.patchValue({
          location: data.data.location,
          latitude: data.data.latitude,
          longitude: data.data.longitude,
        });
        this.updateResultCount();
      }
      // this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  applyFilter() {
    this.form.patchValue({
      color: this.selectedColor,
      type: this.selectedType,
      brand: this.selectedBrand,
      size: this.selectedSize
    });
    this.localStorage.set('category-filters', this.form.value);
    this.modalCtrl.dismiss(this.form.value, null, 'categoryFilters');
  }

  resetFilter() {
    this.form.reset();
    this.localStorage.set('category-filters', this.form.value);
    this.modalCtrl.dismiss(this.form.value);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
